import * as React from 'react'
import { memo } from 'react'
const SvgExpand = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    width="1em"
    height="1em"
  >
    <path d="M11.317 11.883 8.059 8.624a4.894 4.894 0 1 1 .565-.566l3.259 3.259a.4.4 0 1 1-.565.565ZM2 2A4.092 4.092 0 1 0 4.893.8 4.1 4.1 0 0 0 2 2m2.5 5V5.3H2.8a.4.4 0 0 1 0-.8h1.7V2.8a.4.4 0 1 1 .8 0v1.7H7a.4.4 0 0 1 0 .8H5.3V7a.4.4 0 1 1-.8 0" />
  </svg>
)
const Memo = memo(SvgExpand)
export default Memo
